// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';

export const CustomerSearchError = t.struct({
    errorMessage: t.String,
    errorStatus: t.Number,
    hasError: t.Boolean
}, {
    defaultProps: {
        errorMessage: '',
        errorStatus: 0,
        hasError: false
    },
    name: 'CustomerSearchError'
});
